import { render, staticRenderFns } from "./Observer.vue?vue&type=template&id=8c4c9f16"
import script from "./Observer.vue?vue&type=script&lang=js"
export * from "./Observer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports